module.exports = __webpack_public_path__ + "fonts/iconfont.01d07dbb.woff";